import * as React from 'react'

/* Import interfaces here */
import { ITabProps } from './Tab.interfaces'

const Tab: React.FC<ITabProps> = ({ children }) => <React.Fragment>{children}</React.Fragment>

export default Tab
